import config from '../utils/ApiUrl';
import { getCookie, handleSessionExpire } from './session';

const API_URL = config.API_URL;

const fetchAllApplications = async (password) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(
    `${API_URL}/admin-fetch-seller-applications/${password}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionToken}`,
      },
    }
  );
  const data = await response.json();
  return data;
};

const verifySeller = async (formData) => {
  const sessionToken = getCookie();
  if (!sessionToken) return handleSessionExpire();

  const response = await fetch(`${API_URL}/admin-verify-seller`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${sessionToken}`,
    },
    body: JSON.stringify(formData),
  });
  const data = await response.json();
  return data;
};

export { fetchAllApplications, verifySeller };
